import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [meta, setMeta] = useState(null);

  const loadMeta = useCallback(async () => {
    const { data } = await api.get("/meta");
    setMeta(data);
  }, []);

  useEffect(() => {
    if (!localStorage.getItem("mona_token")) return setUser(false);
    api.get("/auth/me").then(async ({ data }) => { await loadMeta(); setUser(data); }).catch(() => { localStorage.removeItem("mona_token"); setUser(false); });
  }, [loadMeta]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("mona_token", data.token);
    await loadMeta();
    setUser(data.user);
  };
  const logout = () => { localStorage.removeItem("mona_token"); setUser(false); setMeta(null); };
  const can = useCallback((...p) => !!user && (user.permissions.includes("*") || p.some((x) => user.permissions.includes(x))), [user]);

  const helpers = useMemo(() => {
    if (!meta) return {};
    const byId = (arr) => Object.fromEntries(arr.map((x) => [x.id, x]));
    const scope = user && !user.permissions.includes("*") && user.location_ids?.length ? user.location_ids : null;
    const myLocs = meta.locations.filter((l) => !scope || scope.includes(l.id));
    return {
      itemById: byId(meta.items), locById: byId(meta.locations), supById: byId(meta.suppliers),
      activeItems: meta.items.filter((i) => i.active !== false), myLocs,
      warehouse: meta.locations.find((l) => l.type === "warehouse"), outlets: meta.locations.filter((l) => l.type === "outlet"),
      myAccounts: meta.cash_accounts.filter((a) => user?.permissions.includes("*") || (user?.cash_account_ids || []).includes(a.id)),
    };
  }, [meta, user]);

  return <Ctx.Provider value={{ user, meta, login, logout, can, loadMeta, ...helpers }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
